const state = {
  visitedViews: [],
  cachedViews: []
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/tagsView.js